/* CreaTiff — scroll reveal for custom sections. Progressive enhancement:
   if this never runs, .ct-reveal content is revealed by the no-JS fallback. */
(function () {
  // Every CreaTiff section requests this file, so it may be included more than
  // once. Bail out after the first run instead of stacking duplicate listeners.
  if (window.__creatiffRevealReady) return;
  window.__creatiffRevealReady = true;

  function init(root) {
    var els = (root || document).querySelectorAll('.ct-reveal:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el, i) {
      el.style.transitionDelay = Math.min(i * 60, 300) + 'ms';
      io.observe(el);
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  // Theme Editor re-renders a section without a page load.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
